import { useState } from "react";
import { Link } from "react-router-dom";
import {
  FaBars,
  FaTimes
} from "react-icons/fa";

import "../styles/clientNavbar.css";

function ClientNavbar() {

  const [menuOpen, setMenuOpen] =
    useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (

    <nav className="client-navbar">

      <div className="client-logo">

        <Link to="/">

          <img
            src="/comp exams.jpeg"
            alt="CompExams Logo"
            className="client-logo-image"
          />

          <span>
            CompExams
          </span>

        </Link>

      </div>

      <ul
        className={
          menuOpen
            ? "client-nav-links active"
            : "client-nav-links"
        }
      >

        <li>

          <Link
            to="/"
            onClick={closeMenu}
          >
            Home
          </Link>

        </li>

        <li>

          <Link
            to="/categories"
            onClick={closeMenu}
          >
            Categories
          </Link>

        </li>

        <li>

          <Link
            to="/exams"
            onClick={closeMenu}
          >
            Exams
          </Link>

        </li>

        <li>

          <Link
            to="/about"
            onClick={closeMenu}
          >
            About
          </Link>

        </li>

        <li>

          <Link
            to="/contact"
            onClick={closeMenu}
          >
            Contact
          </Link>

        </li>

      </ul>

      <div
        className="menu-icon"
        onClick={toggleMenu}
      >

        {menuOpen
          ? <FaTimes />
          : <FaBars />
        }

      </div>

    </nav>

  );

}

export default ClientNavbar;